<mat-chip class="mt-4 text-xs">
  <ng-content></ng-content>
</mat-chip>
